import { normalizePhoneNumber } from '@frontend/phone-numbers';

export const normalizeNumberForBlocking = (phoneNumber?: string | number): string => {
  if (!phoneNumber) return '';
  return normalizePhoneNumber(String(phoneNumber));
};

const getErrorMessage = (error: unknown): string => (error instanceof Error ? error.message : '');

/** The backend rejects creating a number that is already blocked with this cause in the error message. */
export const isBlockedNumberAlreadyBlockedError = (error: unknown): boolean =>
  getErrorMessage(error).includes('blocked number not unique for create operation');

/** The backend rejects deleting a blocked number that is not blocked with this cause in the error message. */
export const isBlockedNumberAlreadyUnblockedError = (error: unknown): boolean =>
  getErrorMessage(error).includes('some blocked numbers not found');
